import { useTranslation } from 'react-i18next'

import { useFetch } from '@reveni-io/reveni-ui'

import useReturnPortalFeatures from '@/common/hooks/useReturnPortalFeatures/useReturnPortalFeatures'
import configurationServices from '@/configuration/services/services'

const useLogisticGeneralConfiguration = ({ storeId, setToastInfo, updateContext, returnPortalId }) => {
  const { t } = useTranslation()
  const {
    data,
    loading,
    setData,
    resetData: resetShipmentsData,
    hasChanges: hasShipmentsChanges,
    fetchData: getShipmentsConfiguration,
  } = useFetch(configurationServices.getShipmentsConfiguration, {
    doInitialRequest: true,
    params: { storeId },
  })
  const { fetchData: editShipmentsConfiguration, loading: editingShipmentsConfiguration } = useFetch(
    configurationServices.editShipmentsConfiguration,
    { doInitialRequest: false }
  )

  const {
    returnPortalFeatures,
    refetchReturnPortalFeatures,
    editReturnPortalPreferences,
    setReturnPortalFeatures,
    hasReturnPortalFeaturesChanges,
    resetReturnPortalFeatures,
  } = useReturnPortalFeatures({ returnPortalId })

  const hasChanges = hasShipmentsChanges || hasReturnPortalFeaturesChanges

  const onShipmentsConfigChange = (field, value) => {
    setData(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }

  const onStoreFeaturesChange = (field, value) => {
    setReturnPortalFeatures(prevData => ({
      ...prevData,
      [field]: value,
    }))
  }

  const resetData = () => {
    resetShipmentsData()
    resetReturnPortalFeatures()
  }

  const onSaveChanges = async () => {
    try {
      if (hasShipmentsChanges) {
        await editShipmentsConfiguration({ storeId, payload: data })
        await getShipmentsConfiguration({ storeId })
        updateContext(info => ({
          ...info,
          selectedStore: {
            ...info.selectedStore,
            preferences: { ...info.selectedStore.preferences, shipping_skip_packing: data?.shipping_skip_packing },
          },
        }))
      }

      if (hasReturnPortalFeaturesChanges) {
        await editReturnPortalPreferences({
          returnPortalId,
          payload: { label_format: returnPortalFeatures?.label_format },
        })
        await refetchReturnPortalFeatures()
      }
      setToastInfo({ show: true, type: 'success', message: t('Configuración guardada correctamente') })
    } catch (error) {
      setToastInfo({ show: true, type: 'error', message: error.errorMessage })
    }
  }

  return {
    data,
    loading,
    resetData,
    onShipmentsConfigChange,
    onStoreFeaturesChange,
    hasChanges,
    onSaveChanges,
    editingShipmentsConfiguration,
    labelFormat: returnPortalFeatures?.label_format,
  }
}

export default useLogisticGeneralConfiguration
